import type {ColumnFragment, ValueFragment} from "app/gql/graphqlSchema";
import {EmptyValue} from "app/employee/controlCard/display/EmptyValue";
import {InvalidValue} from "app/employee/controlCard/display/InvalidValue";
import {AttachmentCollection} from "app/employee/att/AttachmentCollection";
import type {ExtractType} from "app/utils/types";

interface Props {
  column: ExtractType<ColumnFragment, "ControlCardAttachmentCollectionColumn">;
  value: ValueFragment;
}

export const DisplayAttachmentCollection = ({column, value}: Props) => {
  let result: JSX.Element;
  if (value.__typename === "ControlCardExistingAttachmentCollectionOwningRefValue") {
    result = (
      <AttachmentCollection
        attCollection={value.attachmentCollection}
        canDelete={false}
        canUpload={false}
        name={column.title}
      />
    );
  } else if (value.__typename === "ControlCardEmptyValue") {
    result = <EmptyValue />;
  } else {
    result = <InvalidValue />;
  }

  return result;
};
